module.exports = {
  headline: 'Terms & Conditions',
  index: [
    'General', 
    'Agreement and Order', 
    'Login and User Profile', 
    'Personal Data',
    'Integrity policy',
    'Prices, Fees and Payment',
    'Shipping and Delivery',
    'Relationship Between Spotin AB and the Customer',
    'Reclamations and Returns',
    'Changes to these Terms & Conditions',
    'Applicable Law and Dispute'
  ],
  terms: `
    <p>
    These conditions have been defined by Spotin AB on the 3rd of March 2023.
    </p>

    <p>
    Spotin is a web-based service that enable customers to purchase items 
    directly from different sellers with one single checkout and order. The 
    items that the customer adds to its shopping bag within the service Spotin 
    may be kept and moved with the user when the user switches from one website 
    to another, which means that the user can fill its shoppingbag with items 
    from different sellers, and from different websites before checking out and 
    thereby placing an order. 
    </p>

    <p>
    Placing an order means that the user enter a purchase agreement with one or 
    many sellers, but all handling with regards to payment and terms and 
    conditions for delivery etc. of the order is consolidated to a single 
    process via the service Spotin.
    </p>

    <h2 anchor>  
    1. General
    </h2>

    
    <span>
    1.1 
    </span>
    <p class="m-list">
    These Terms and Conditions ("Terms") are applicable when a Customer 
    ("Customer") makes an order via the service Spotin ("SPOTIN"). SPOTIN is 
    provided by Spotin AB, (Org. nr: 559027-1549). Spotin AB is acting as a 
    mediator in the occasion of an agreement ("Agreement") of purchase of items 
    between the Customer and the seller(s) which are connected to Spotin and 
    are supplying the specific items. The seller(s) that the Customer enters 
    into an agreement with are referred to as "Seller" or "Sellers" in the 
    following sections and their full identification is clearly defines by the 
    information provided to the Customer at the time of confirming and placing 
    and order via SPOTIN.
    </p>

    <span>
    1.2 
    </span>
    <p class="m-list">
    Spotin AB reserve itself for sold out items as well as possible image or 
    text errors within SPOTIN. For example, errors deriving from the Sellers’ 
    own product description, incorrect pricing or price adjustments (such as 
    altered prices by the Seller, or exchange rates) or incorrect information 
    regarding if an item is in stock. Spotin AB reserves the right to correct 
    such errors and to alter or update the information at any time.
    </p>

    <span>
    1.3 
    </span>
    <p class="m-list">
    The service SPOTIN and its user interface is owned by Spotin AB. The 
    information is protected by law with consideration to e.g. copyright, 
    marketing and trademarks, which may belong to Spotin AB, Sellers or third 
    parties. This means that trademarks, company names, product names, images 
    and graphic, design, layout as well as information about products, services 
    and other content which are provided or made available via SPOTIN are not 
    allowed to be copied or used without prior written consent by Spotin AB.
    </p>


    <h2 anchor>  
    2. Agreement and Order
    </h2>

    <span>
    2.1 
    </span>
    <p class="m-list">
    To be able to place an order via SPOTIN the Customer must accept these 
    Terms and Conditions. By accepting these Terms and Conditions the Customer 
    commits to follow the Terms and Conditions in their entirety.
    </p>

    <span>
    2.2 
    </span>
    <p class="m-list">
    With accepting the Terms and Conditions the Customer confirms that he/she 
    has read and accepts the Sellers’ and the Payment Provider’s respective 
    Terms and Conditions for the placed order (see definition in section 5 
    below).
    </p>

    <span>
    2.3 
    </span>
    <p class="m-list">
    An Agreement between Customer and Seller, for which these Terms and 
    Conditions and respective concerned Sellers’ Terms and Conditions are 
    applied, are entered into only when the Customers has paid the order via 
    SPOTIN and has received a written order confirmation via SPOTIN from the or 
    the Seller(s) who are to deliver the Customer's order. Spotin AB request 
    Customers to save the order confirmations for any possible contacts with 
    respective Seller's customer service.
    </p>

    <span>
    2.4 
    </span>
    <p class="m-list">
    Spotin AB are striving to ensure that the Customer receives an order 
    confirmation no later than 72h from that the Customer has completed and paid 
    for an order within SPOTIN. (The order confirmation to the Customer is sent 
    as soon as all the Sellers within the respective order has processed their 
    part of the order.) An order can only be placed via SPOTIN if it can be 
    ensured that the Customer’s address details are valid, and that the payment 
    has been received.
    </p>


    <h2 anchor>  
    3. Login and User Profile
    </h2>

    <span>
    3.1
    </span>
    <p class="m-list">
    If the Customer choses to create a user profile with SPOTIN the Customer 
    accepts that its user details are saved for future use within SPOTIN. No 
    payment details will be saved in SPOTIN.
    </p>

    <span>
    3.2 
    </span>
    <p class="m-list">
    The Customer is by itself responsible for keeping login details, where such 
    are used, for SPOTIN secret, and undertakes the responsibility to ensure 
    that no other person can use these login details. Username and login should 
    be stored such that no unauthorized person can access the information. The 
    Customer shall immediately notify Spotin AB if unauthorized use of the 
    account is suspected. The Customer is responsible for all purchases made 
    with its user profile if Spotin AB has not been notified prior to the 
    unauthorized use.
    </p>

    <span>
    3.3 
    </span>
    <p class="m-list">
    If Spotin AB are suspecting that the Customer is misusing its user account 
    or its login details in any way that are in conflict with these Terms and 
    Conditions Spotin AB reserves the right to block the Customer from SPOTIN. 
    Spotin AB also reserves the right to assign new login details to the 
    Customer at any time.
    </p>


    <h2 anchor>  
    4. Personal Data
    </h2>

    <span>
    4.1 
    </span>
    <p class="m-list">
    By accepting these Terms and Conditions the Customer consent to Spotin AB's 
    (i) handling of the Customers personal data; (ii) the use of cookies, all in 
    accordance with this section 4. Spotin AB can from time to another come to 
    revise this Integrity Policy in accordance with 5 below, which is also 
    published on <a data-to="/terms">spotin.com/terms</a> and which the Customer 
    then actively have to accept for the new integrity policy to be effective.
    </p>

    <span>
    4.2
    </span>
    <p class="m-list">
    The Customer completes orders via SPOTIN through Spotin AB:s domain and via 
    a external payment service provider. At the time of placing an order the 
    Customer may be asked to provide personal data which are necessary to 
    process the order. The Customer confirms that by leaving their personal data 
    that the personal data is correctly and completely filled in. The Customer 
    is responsible for details filled in incorrectly.
    </p>

    <span>
    4.3
    </span> 
    <p class="m-list">
    All data collection made in SPOTIN besides information that is needed to 
    process orders from Customers is anonymous statistical data and is not 
    traceable to specific user’s use of SPOTIN. The customer’s personal data 
    will not be used in relationship with data collected within SPOTIN.
    </p>

    <h2 anchor>  
    5. Integrity policy
    </h2>
    
    <p class="m-list">
    Please see <a data-to="/privacy">spotin.com/privacy</a> for details on how 
    Spotin safeguards user data.
    </p>

    <h2 anchor>  
    6. Prices, Fees and Payment
    </h2>

    <span>
    6.1
    </span>
    <p class="m-list">
    Spotin AB are using external parties to supply the payment services in 
    SPOTIN, ("Payment service"). Spotin AB reserves the right to change Payment 
    services at any time (without affect to already signed Agreements).
    </p>

    <span>
    6.2
    </span>
    <p class="m-list">
    The prices mediated from the respective Seller are effective when placing 
    an order via SPOTIN. All prices are defined in local currencies based on 
    the Customer’s geolocation if prices in the local currency is available 
    from the Seller. 
    </p>

    <span>
    6.3
    </span>
    <p class="m-list">
    In case prices are not available from the Seller in the Customer’s local 
    currency SPOTIN may convert the price to the Customer’s local currency if 
    agreed to by the Seller.
    </p>

    <span>
    6.4
    </span>
    <p class="m-list">
    All prices include VAT unless cross-market purchase is made from a Seller 
    located outside the Customer’s market. In such case SPOTIN shows prices 
    excluding VAT for the specific Seller and informs the Customer at the time
    of placing an order. 
    </p>

    <span>
    6.5
    </span>
    <p class="m-list">
    The total price in SPOTIN at the time of placing the order includes fees 
    from the Payment service chosen by the Customer. Shipping fees from the 
    respective Seller are defined separately and in accordance with respective 
    Seller's Terms and Conditions.
    </p>

    <span>
    6.6
    </span>
    <p class="m-list">
    Customers can pay for orders using the payment options offered by the 
    Payment services, and presented by SPOTIN at the time of placing the order, 
    e.g. by invoice or credit/debit card.
    </p>

    <span>
    6.7
    </span>
    <p class="m-list">
    Customer’s payment for orders which cannot be confirmed by respective 
    Seller, which therefore does not lead to an Agreement, will be refunded to 
    the Customer.
    </p>


    <h2 anchor>  
    7. Shipping and Delivery
    </h2>

    <span>
    7.1
    </span>
    <p class="m-list">
    The Customer is aware of and accepts that the different Sellers which are 
    connected to SPOTIN with which the Customer enters into an Agreement with 
    for confirmed orders are applying their own Terms and Conditions with 
    regards to, but not limited to, delivery, right to return, purchase on 
    approval. Such Terms and Conditions are made available to the Customer in 
    connection with every order and the Customer must accept such Terms and 
    Conditions to enter into an Agreement.
    </p>


    <h2 anchor>  
    8. Relationship Between Spotin AB and the Customer
    </h2>

    <span>
    8.1
    </span>
    <p class="m-list">
    In relationship to the Customer Spotin AB only takes the role as a Mediator 
    of product information from the Seller to the Customer, and for the 
    Customer’s order to the Seller and thereto related confirmation of 
    transactions. Spotin AB also enables the Customer to place orders via SPOTIN 
    to different Sellers in one single order. Spotin AB is not taking the role 
    as Seller or counterpart in agreements in relationship to the Customer 
    with regards to the Agreement(s) made between the Customer and the Seller 
    via SPOTIN. Spotin AB shall not be held liable by the Customer e.g. for 
    orders that are not confirmed by a Seller or Agreements which are not 
    fulfilled by a Seller or defects in received items. Spotin AB shall also 
    not be held responsible by the Customer for any faults in Payment service 
    providers' services offered within SPOTIN at any given time.
    </p>  

    <h2 anchor>  
    9. Reclamations and Returns
    </h2>

    <span>
    9.1
    </span>
    <p class="m-list">
    All returns and reclamations for items ordered via SPOTIN shall be made to 
    the respective Seller.
    </p>  


    <h2 anchor>  
    10. Changes to these Terms & Conditions
    </h2>

    <span>
    10.1
    </span>
    <p class="m-list">
    Spotin AB reserves the right to make changes to these Terms and Conditions 
    at any given time. All changes to these Terms and Conditions will be 
    provided to users through SPOTIN and published on 
    spotin.com/terms. Any version of these Terms and 
    Conditions is effective from the time that the Customer accepts the Terms 
    and Conditions in connection with using SPOTIN.
    </p>


    <h2 anchor>  
    11. Applicable Law and Dispute
    </h2>

    <span>
    11.1
    </span>
    <p class="m-list">
    Any dispute with regards to the interpretation or application of these 
    Terms and Conditions shall be interpreted in accordance with Swedish law and 
    determined by Swedish courts.
    </p>
  `,
};


// WEBPACK FOOTER //
// ./pages/content/terms_EN.js